export default __webpack_public_path__ + "static/media/cafeshow_own02.8612ffdd.png";